// extracted by mini-css-extract-plugin
export default {"view-toggle":"viewToggle_view-toggle__BR3JN","toggle-btn":"viewToggle_toggle-btn__SSvsH","active":"viewToggle_active__wd4g5"};